import { ProductsDetailsStore, ProductsDetailsActions } from './types';

export const defaultState: ProductsDetailsStore = {
  error: null,
  isLoading: false,
  isLoaded: false,
  product: null,
  isRelatedProductsLoading: false,
  isRelatedProductsLoaded: false,
  errorRelatedProducts: null,
  isLoadingProductVariants: false,
  isLoadedProductVariants: true,
  errorProductVariants: null,
  isLoadingMaterials: false,
  isLoadedProductMaterials: false,
  errorProductMaterials: null,
  materialColors: [],
  activeProductProperty: null,
  productSeriesProducts: [],
  relatedProducts: [],
};

const reducer = (
  state: ProductsDetailsStore = defaultState,
  action: { type: ProductsDetailsActions; payload?: any }
): ProductsDetailsStore => {
  switch (action.type) {
    /*
     * PRODUCT DETAILS ACTIONS
     */

    case ProductsDetailsActions.FetchDetailsBegin: {
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
        error: null,
      };
    }
    case ProductsDetailsActions.FetchDetailsError: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        error: action.payload,
      };
    }
    case ProductsDetailsActions.FetchDetailsSuccess: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        error: null,
        ...action.payload,
      };
    }

    /*
     * RELATED PRODUCTS ACTIONS
     */

    case ProductsDetailsActions.FetchRelatedProductsBegin: {
      return {
        ...state,
        isRelatedProductsLoading: true,
        isRelatedProductsLoaded: false,
        errorRelatedProducts: null,
      };
    }
    case ProductsDetailsActions.FetchRelatedProductsSuccess: {
      return {
        ...state,
        isRelatedProductsLoading: false,
        isRelatedProductsLoaded: true,
        errorRelatedProducts: null,
        ...action.payload,
      };
    }
    case ProductsDetailsActions.FetchRelatedProductsError: {
      return {
        ...state,
        isRelatedProductsLoading: false,
        isRelatedProductsLoaded: true,
        errorRelatedProducts: null,
      };
    }

    /*
     * PRODUCT VARIANTS ACTIONS
     */

    case ProductsDetailsActions.FetchProductVariantsBegin: {
      return {
        ...state,
        isLoadingProductVariants: true,
        isLoadedProductVariants: false,
        errorProductVariants: null,
      };
    }
    case ProductsDetailsActions.FetchProductVariantsSuccess: {
      return {
        ...state,
        product: { ...state.product, product_variants: action.payload.productVariants },
        isLoadingProductVariants: false,
        isLoadedProductVariants: true,
        errorProductVariants: null,
      };
    }
    case ProductsDetailsActions.FetchProductVariantsError: {
      return {
        ...state,
        isLoadingProductVariants: false,
        isLoadedProductVariants: true,
        errorProductVariants: action.payload,
      };
    }

    /*
     * MATERIAL COLORS ACTIONS
     */

    case ProductsDetailsActions.FetchMaterialColorsBegin: {
      return {
        ...state,
        isLoadingMaterials: true,
        isLoadedProductMaterials: false,
        errorProductMaterials: null,
      };
    }
    case ProductsDetailsActions.FetchMaterialColorsSuccess: {
      return {
        ...state,
        materialColors: action.payload,
        isLoadingMaterials: false,
        isLoadedProductMaterials: true,
        errorProductMaterials: null,
      };
    }
    case ProductsDetailsActions.FetchMaterialColorsError: {
      return {
        ...state,
        isLoadingMaterials: false,
        isLoadedProductMaterials: true,
        errorProductMaterials: action.payload,
      };
    }

    /*
     * Displayed overlay
     */

    case ProductsDetailsActions.DisplayProductProperty: {
      return {
        ...state,
        ...action.payload,
      };
    }
    default: {
      return state;
    }
  }
};

export default reducer;
